<header class="main__content__header modal-header">
    <h2 class="modal-title">Por favor, confirme os dados abaixo:</h2>
</header>
<main class="main__content__modal modal-body">
    <div class="py-1">
        <span class="sub-title">Nome:</span> {{recadastramento?.nome}}
    </div>
    <div class="py-1">
        <span class="sub-title">CPF:</span> {{recadastramento?.cpf | cpfCnpj}}
    </div>
    <div class="py-1">
        <span class="sub-title">Email:</span> {{recadastramento?.email}}
    </div>
    <div class="py-1">
        <span class="sub-title">Email secundário:</span> {{recadastramento?.emailSecundario || 'Não informado'}}
    </div>
    <div class="py-1">
        <span class="sub-title">Celular:</span> {{recadastramento?.celular | Phone}}
    </div>
    <div class="py-1">
        <span class="sub-title">Telefone:</span> {{recadastramento?.telefone | Phone}}
    </div>
    <div class="py-1">
        <span class="sub-title">Endereço:</span> {{recadastramento.endereco}}
    </div>
    <div class="py-1">
        <span class="sub-title">Complemento:</span> {{recadastramento.complemento}}
    </div>
</main>
<footer class="main__content__footer modal-footer">
    <button class="btn button-primary col-md-4 col-sm-12 mr-lg-1" (click)="confirm()">Confirmar dados</button>
    <button class="btn button-outline-primary col-md-4 col-sm-12 mr-lg-1" (click)="go()">Atualizar dados</button>
</footer>
